var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Bold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-Bold",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M8,15H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H7a4,4,0,0,1,4,4V5a4.024,4.024,0,0,1-.5,1.9A3.983,3.983,0,0,1,12,10v1A4,4,0,0,1,8,15ZM3,9v3H8a1,1,0,0,0,1-1V10A1,1,0,0,0,8,9ZM3,3V6H7A1,1,0,0,0,8,5V4A1,1,0,0,0,7,3Z",
    transform: "translate(6 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Bold);
export default __webpack_public_path__ + "static/media/icon-24-Bold.3d1156d9909071ee8022498fcdfe0cb8.svg";
export { ForwardRef as ReactComponent };